(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5847],{

/***/ 23126:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thi-tinh-huong/[slug]",
      function () {
        return __webpack_require__(75354);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AudioPlayer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/plyr/dist/plyr.min.js
var plyr_min = __webpack_require__(21443);
var plyr_min_default = /*#__PURE__*/__webpack_require__.n(plyr_min);
// EXTERNAL MODULE: ./node_modules/plyr/dist/plyr.css
var plyr = __webpack_require__(5667);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./src/utils/axios.js
var axios = __webpack_require__(92369);
;// CONCATENATED MODULE: ./src/service/gplx.speech.service.js




var synthesizeTextToSpeech = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(text, gender) {
        var config, resp, audioBlob;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    config = {
                        url: "/texttospeech/synthesize",
                        method: "POST",
                        data: {
                            text: text,
                            gender: gender
                        },
                        responseType: "arraybuffer"
                    };
                    return [
                        4,
                        (0,axios/* handleRequest */.X)(config)
                    ];
                case 1:
                    resp = _state.sent();
                    if ((0,_instanceof/* default */.Z)(resp, ArrayBuffer)) {
                        audioBlob = new Blob([
                            resp
                        ], {
                            type: "audio/mp3"
                        });
                        return [
                            2,
                            URL.createObjectURL(audioBlob)
                        ];
                    }
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function synthesizeTextToSpeech(text, gender) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/AudioPlayer.js
/* eslint-disable react/prop-types */ 







var AudioPlayer = function(param) {
    var text = param.text, _index = param.index, index = _index === void 0 ? "" : _index;
    var ref = (0,react.useState)("male"), voiceName = ref[0], setVoiceName = ref[1];
    var playerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var player = new (plyr_min_default())("#player-".concat(index), {
            speed: {
                selected: 1,
                options: [
                    0.25,
                    0.5,
                    1,
                    1.25,
                    1.5
                ]
            }
        });
        playerRef.current = player;
        player.on("play", function() {
            if (!player.source) fetchAudio(voiceName);
        });
        return function() {
            player.destroy();
        };
    }, [
        text,
        index
    ]);
    var fetchAudio = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(voiceName) {
            var audioUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            synthesizeTextToSpeech(text, voiceName)
                        ];
                    case 1:
                        audioUrl = _state.sent();
                        if (audioUrl) {
                            playerRef.current.source = {
                                type: "audio",
                                sources: [
                                    {
                                        src: audioUrl,
                                        type: "audio/mp3"
                                    }
                                ]
                            };
                            playerRef.current.play();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchAudio(voiceName) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeVoice = function(name) {
        if (name !== voiceName) {
            setVoiceName(name);
            fetchAudio(name);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                my: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        alt: "male",
                        src: "/img/male.jpg",
                        onClick: function() {
                            return changeVoice("male");
                        },
                        sx: {
                            border: voiceName === "male" ? "2px solid blue" : "none",
                            cursor: "pointer",
                            width: 30,
                            height: 30
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        alt: "female",
                        src: "/img/female.jpg",
                        onClick: function() {
                            return changeVoice("female");
                        },
                        sx: {
                            border: voiceName === "female" ? "2px solid blue" : "none",
                            width: 30,
                            height: 30,
                            cursor: "pointer"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                        id: "player-".concat(index),
                        className: "plyr",
                        controls: true,
                        children: "Your browser does not support the audio element."
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_AudioPlayer = (AudioPlayer);


/***/ }),

/***/ 75354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Situation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/layouts/index.js + 21 modules
var layouts = __webpack_require__(85307);
// EXTERNAL MODULE: ./src/redux/slices/blog/blog.comment.js
var blog_comment = __webpack_require__(29050);
// EXTERNAL MODULE: ./src/redux/store.js + 10 modules
var store = __webpack_require__(33599);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/components/AdsContact.js
var AdsContact = __webpack_require__(95352);
// EXTERNAL MODULE: ./src/components/AppSection.js
var AppSection = __webpack_require__(27941);
// EXTERNAL MODULE: ./src/components/GoogleAds.js
var GoogleAds = __webpack_require__(28075);
// EXTERNAL MODULE: ./src/components/HackerthonAds.js
var HackerthonAds = __webpack_require__(66946);
// EXTERNAL MODULE: ./src/hooks/useResponsive.js
var useResponsive = __webpack_require__(55102);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./src/sections/situation/Claimnation.js
var Claimnation = __webpack_require__(6195);
// EXTERNAL MODULE: ./src/sections/situation/GuideSection.js
var GuideSection = __webpack_require__(86969);
// EXTERNAL MODULE: ./src/sections/situation/MenuSection.js
var MenuSection = __webpack_require__(31622);
// EXTERNAL MODULE: ./src/sections/situation/SituationHeader.js
var SituationHeader = __webpack_require__(55486);
// EXTERNAL MODULE: ./src/sections/situation/SituationWelcome.js
var SituationWelcome = __webpack_require__(41593);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(19267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/AudioPlayer.js + 1 modules
var AudioPlayer = __webpack_require__(11566);
// EXTERNAL MODULE: ./src/components/FBSocial.js
var FBSocial = __webpack_require__(36239);
// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
// EXTERNAL MODULE: ./src/components/Markdown.js
var Markdown = __webpack_require__(81320);
// EXTERNAL MODULE: ./src/components/YoutubePlayer.js + 1 modules
var YoutubePlayer = __webpack_require__(565);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/redux/slices/gplx.situation.slice.js
var gplx_situation_slice = __webpack_require__(10765);
// EXTERNAL MODULE: ./src/sections/comment/CommentList.js
var CommentList = __webpack_require__(16634);
// EXTERNAL MODULE: ./src/sections/comment/CommentNewForm.js
var CommentNewForm = __webpack_require__(79136);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/video.js/dist/video.es.js
var video_es = __webpack_require__(85215);
// EXTERNAL MODULE: ./node_modules/videojs-contrib-quality-levels/dist/videojs-contrib-quality-levels.js
var videojs_contrib_quality_levels = __webpack_require__(78984);
// EXTERNAL MODULE: ./node_modules/videojs-http-source-selector/dist/videojs-http-source-selector.es.js
var videojs_http_source_selector_es = __webpack_require__(85258);
// EXTERNAL MODULE: ./node_modules/videojs-youtube/dist/Youtube.js
var Youtube = __webpack_require__(72575);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(33726);
;// CONCATENATED MODULE: ./src/sections/situation/VideoPlayerPreview.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 









// ----------------------------------------------------------------------
function VideoPlayerPreview(param) {
    var video = param.video, prevItem = param.prevItem, nextItem = param.nextItem;
    var type = "VIDEO";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: type === "VIDEO" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewVideo, {
            video: video,
            prevItem: prevItem,
            nextItem: nextItem
        })
    });
}
// ----------------------------------------------------------------------
function PreviewVideo(param) {
    var video = param.video, prevItem = param.prevItem, nextItem = param.nextItem;
    var playerRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.situation;
    }), isAnswered = ref.isAnswered, hint = ref.hint;
    (0,react.useEffect)(function() {
        if (!playerRef.current) {
            var options = {
                playbackRates: [
                    0.5,
                    1,
                    1.5,
                    2
                ],
                fluid: true,
                fill: true,
                responsive: true,
                controls: true,
                preload: "auto",
                autoplay: true,
                aspectRatio: "16:9",
                controlBar: {
                    remainingTimeDisplay: false,
                    currentTimeDisplay: true,
                    pictureInPictureToggle: false,
                    playbackRateMenuButton: false,
                    timeDivider: true,
                    durationDisplay: true
                },
                userActions: {
                    hotkeys: function hotkeys(event) {
                        // `this` is the player in this context
                        event.preventDefault();
                        if (event.target.type === "button") {
                            event.target.blur();
                        }
                        if (event.which === 32) {
                            spaceFnc(event);
                            return false;
                        }
                        return true;
                    }
                },
                inactivityTimeout: 0,
                plugins: {
                    httpSourceSelector: {
                        default: "auto"
                    }
                },
                html5: {
                    vhs: {
                        overrideNative: true
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false
                }
            };
            var player = playerRef.current = (0,video_es["default"])("video_1", options);
            video_es["default"].log.level("off");
            player.playsinline(true);
        }
    }, []);
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        // player.on('timeupdate', function () {
        //   console.log(this.currentTime());
        // });
        return function() {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [
        playerRef
    ]);
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        if (!player.ended()) if (hint) player.pause();
        else player.play();
    }, [
        hint
    ]);
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        if (video) {
            var id = video.id;
            player.poster("".concat(config/* BASEURL */.Hc, "/stream/video/").concat(id, "/thumbnail/thumb.jpg"));
            player.src({
                src: "".concat(config/* BASEURL */.Hc, "/stream/video/").concat(id, "/index.m3u8"),
                type: "application/x-mpegURL"
            });
            drawNavigateBar(player);
        }
        return function() {
            dispatch((0,gplx_situation_slice/* setAnswered */.pz)(false));
            try {
                var ref;
                player === null || player === void 0 ? void 0 : (ref = player.controlBar) === null || ref === void 0 ? void 0 : ref.removeChild("Component");
            } catch (e) {
                console.log();
            }
        };
    }, [
        video
    ]);
    var spaceFnc = (0,react.useCallback)(function(event) {
        event.preventDefault();
        if (event.target.type === "button") {
            event.target.blur();
        }
        if (event.which === 32) {
            dispatch((0,gplx_situation_slice/* setAnswered */.pz)(true));
        } else if (event.which === 37 && prevItem) {
            router.push({
                pathname: "/thi-tinh-huong/".concat(prevItem === null || prevItem === void 0 ? void 0 : prevItem.slug)
            }, undefined, {
                scroll: false
            });
        } else if (event.which === 39 && nextItem) {
            router.push({
                pathname: "/thi-tinh-huong/".concat(nextItem === null || nextItem === void 0 ? void 0 : nextItem.slug)
            }, undefined, {
                scroll: false
            });
        }
    }, [
        video
    ]);
    (0,react.useEffect)(function() {
        if (!isAnswered) {
            document.addEventListener("keydown", spaceFnc, false);
            document.addEventListener("keypress", spaceFnc, false);
        }
        return function() {
            document.removeEventListener("keydown", spaceFnc, false);
            document.removeEventListener("keypress", spaceFnc, false);
        };
    }, [
        spaceFnc,
        isAnswered
    ]);
    (0,react.useEffect)(function() {
        var id = video.id, start = video.start, end = video.end, orderNo = video.orderNo;
        if (isAnswered) {
            var player = playerRef.current;
            var currentTime = player.currentTime();
            var duration = player.duration();
            var diff = (end - start) / 5;
            var score = 0;
            if (currentTime >= start && currentTime < start + diff) {
                dispatch((0,gplx_situation_slice/* addSituationAnswer */.Ub)({
                    id: id,
                    orderNo: orderNo,
                    seletedTime: currentTime,
                    score: 5
                }));
                score = 5;
            } else if (currentTime >= start + diff && currentTime < start + diff * 2) {
                dispatch((0,gplx_situation_slice/* addSituationAnswer */.Ub)({
                    id: id,
                    orderNo: orderNo,
                    seletedTime: currentTime,
                    score: 4
                }));
                score = 4;
            } else if (currentTime >= start + diff * 2 && currentTime < start + diff * 3) {
                dispatch((0,gplx_situation_slice/* addSituationAnswer */.Ub)({
                    id: id,
                    orderNo: orderNo,
                    seletedTime: currentTime,
                    score: 3
                }));
                score = 3;
            } else if (currentTime >= start + diff * 3 && currentTime < start + diff * 4) {
                dispatch((0,gplx_situation_slice/* addSituationAnswer */.Ub)({
                    id: id,
                    orderNo: orderNo,
                    seletedTime: currentTime,
                    score: 2
                }));
                score = 2;
            } else if (currentTime >= start + diff * 4 && currentTime <= end) {
                dispatch((0,gplx_situation_slice/* addSituationAnswer */.Ub)({
                    id: id,
                    orderNo: orderNo,
                    seletedTime: currentTime,
                    score: 1
                }));
                score = 1;
            } else dispatch((0,gplx_situation_slice/* addSituationAnswer */.Ub)({
                id: id,
                orderNo: orderNo,
                seletedTime: currentTime,
                score: 0
            }));
            drawResultBar(player, currentTime, duration, diff, start, end, score);
        } else {
            var player1 = playerRef.current;
            player1.controlBar.removeChild("Button");
            player1.currentTime(0);
            player1.play();
            window.player = player1;
        }
    }, [
        isAnswered
    ]);
    var drawResultBar = function(player, currentTime, duration, diff, start, end, score) {
        var marginLeftSelect = currentTime / duration * 100;
        var timeWidth = diff / duration * 100;
        var myButton = player.controlBar.addChild("Button", {
            className: "result-bar"
        }, 0);
        // Create our button's DOM Component
        var resultDiv = myButton.el();
        resultDiv.innerHTML = '<div class="result-div"><img style="margin-left:'.concat(marginLeftSelect, '%;height:35px;" src="/icons/flag.png"/>') + '<span class="result-time">'.concat(score, "</span>");
        resultDiv.innerHTML += '<span class="result-answer" style="right:'.concat((duration - start) / duration * 100, '%;">').concat(start, "</span>");
        for(var i = 0; i < 5; i++){
            var color = "red";
            if (i === 0) color = "#008e2c";
            else if (i === 1) color = "#39e500";
            else if (i === 2) color = "#c2e500";
            else if (i === 3) color = "#e56a00";
            else if (i === 4) color = "#e50000";
            var marginLeftStart = (start + diff * i) / duration * 100;
            resultDiv.innerHTML += '<span class="result-answer" style="left:'.concat(marginLeftStart, "%;width:").concat(timeWidth, "%;background-color:").concat(color, '"></span>');
        }
        resultDiv.innerHTML += '<span class="result-answer" style="left:'.concat(end / duration * 100, '%;">').concat(end, "</span>");
        resultDiv.innerHTML += "</div>";
    };
    var drawNavigateBar = function(player) {
        var ref;
        var controlBar = (ref = player.controlBar) === null || ref === void 0 ? void 0 : ref.addChild("Component", {
            className: "my-navigation"
        }, 0);
        // Create our button's DOM Component
        var resultDiv = controlBar.el();
        resultDiv.innerHTML = '<div class="my-navigation-div">' + '<button class="my-button space" onclick="onSpace()">[SPACE]</button>' + '<button class="my-button reset" onclick="onReset()">RESET</button>' + '<button class="my-button" onclick="onBack()"><< Trước</button>' + '<button class="my-button" onclick="onNext()">Sau >></button>' + "</div>";
        window.onNext = function() {
            if (nextItem) router.push({
                pathname: "/thi-tinh-huong/".concat(nextItem === null || nextItem === void 0 ? void 0 : nextItem.slug)
            }, undefined, {
                scroll: false
            });
        };
        window.onBack = function() {
            if (prevItem) router.push({
                pathname: "/thi-tinh-huong/".concat(prevItem === null || prevItem === void 0 ? void 0 : prevItem.slug)
            }, undefined, {
                scroll: false
            });
        };
        window.onSpace = function() {
            dispatch((0,gplx_situation_slice/* setAnswered */.pz)(true));
        };
        window.onReset = function() {
            dispatch((0,gplx_situation_slice/* setAnswered */.pz)(false));
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        id: "video_1",
        className: "video-js vjs-theme-city",
        playsInline: true
    });
}

;// CONCATENATED MODULE: ./src/sections/situation/VideoSection.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ "use client";

















var style = {
    position: "absolute",
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "100%",
    p: 2,
    margin: 0
};
function VideoSection(param) {
    var item = param.item, prevItem = param.prevItem, nextItem = param.nextItem;
    var theme = (0,useTheme/* default */.Z)();
    var translate = (0,useLocales/* default */.Z)().translate;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.situation;
    }), answers = ref.answers, isAnswered = ref.isAnswered, hint = ref.hint;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "sm");
    var currentAnswer = answers === null || answers === void 0 ? void 0 : answers.find(function(a) {
        return a.id === item.id;
    });
    var spaceHandle = function() {
        if (isAnswered) {
            dispatch((0,gplx_situation_slice/* setAnswered */.pz)(false));
            dispatch((0,gplx_situation_slice/* removeSituationAnswer */.DW)(item));
        } else dispatch((0,gplx_situation_slice/* setAnswered */.pz)(true));
    };
    var handleCloseHint = function() {
        dispatch((0,gplx_situation_slice/* setHint */.V0)(false));
    };
    var handleOpenHint = function() {
        dispatch((0,gplx_situation_slice/* setHint */.V0)(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 1,
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayerPreview, {
                video: item,
                prevItem: prevItem,
                nextItem: nextItem
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                disablePortal: true,
                open: hint || false,
                onClose: handleCloseHint,
                style: {
                    position: "absolute"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: (0,_object_spread/* default */.Z)({}, style),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                            children: item.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioPlayer/* default */.Z, {
                            text: item.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: handleCloseHint,
                            sx: {
                                px: 5,
                                float: "right"
                            },
                            color: "warning",
                            variant: "contained",
                            size: "medium",
                            children: hint ? "Ẩn gợi \xfd" : "Gợi \xfd"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                fontWeight: 500,
                color: "error",
                children: item.title
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "body2",
                textAlign: "center",
                children: [
                    " ",
                    translate("situation.guide")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                bgcolor: theme.palette.background.neutral,
                spacing: 5,
                px: 0,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        flex: 1,
                        variant: "subtitle1",
                        children: [
                            "Đ\xe3 l\xe0m: ",
                            answers === null || answers === void 0 ? void 0 : answers.length,
                            "/120"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        flex: 1,
                        variant: "subtitle1",
                        children: [
                            "Điểm: ",
                            currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.score,
                            " ( ",
                            currentAnswer && Math.round((currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.seletedTime) * 10) / 10,
                            "s)"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleOpenHint,
                        color: "warning",
                        sx: {
                            px: isDesktop ? 5 : 1
                        },
                        variant: "contained",
                        size: "medium",
                        children: hint ? "Ẩn gợi \xfd" : "Gợi \xfd"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/thi-tinh-huong/".concat(prevItem === null || prevItem === void 0 ? void 0 : prevItem.slug),
                        passHref: true,
                        scroll: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: !prevItem,
                            variant: "outlined",
                            size: "large",
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "material-symbols:arrow-back-ios"
                            })
                        })
                    }),
                    !isAnswered && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: spaceHandle,
                        fullWidth: true,
                        variant: "contained",
                        size: "large",
                        children: " SPACE (Ph\xedm c\xe1ch)"
                    }),
                    isAnswered && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "warning",
                        onClick: spaceHandle,
                        fullWidth: true,
                        variant: "contained",
                        size: "large",
                        children: " L\xe0m lại"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/thi-tinh-huong/".concat(nextItem === null || nextItem === void 0 ? void 0 : nextItem.slug),
                        passHref: true,
                        scroll: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: !nextItem,
                            variant: "outlined",
                            size: "large",
                            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "material-symbols:arrow-forward-ios"
                            })
                        })
                    })
                ]
            }),
            item && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FBSocial/* SocialShare */.D, {
                        title: item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: "GỢI \xdd 120 T\xccNH HUỐNG M\xd4 PHỎNG TỔNG HỢP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* PreviewYoutube */.M, {
                        videoId: "sUM8LgbJnMA",
                        autoplay: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Score, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        sx: {
                            display: "flex",
                            mb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                children: translate("button.comment")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "caption",
                                children: "Ấn SPACE trước khi b\xecnh luận nh\xe9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentNewForm/* default */.Z, {
                        itemId: item === null || item === void 0 ? void 0 : item.orderNo,
                        type: "SITUATION"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList/* default */.Z, {})
                ]
            })
        ]
    });
}
function Score() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 1,
            p: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "subtitle1",
                    children: "PHƯƠNG PH\xc1P CHẤM ĐIỂM"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    children: "Trong mỗi t\xecnh huống c\xf3 02 mốc thời điểm 5đ v\xe0 0đ:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "+ 5 điểm:"
                        }),
                        " thời điểm bắt đầu c\xf3 dấu hiệu ph\xe1t hiện ra t\xecnh huống nguy hiểm, l\xe1i xe cần xử l\xfd."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "+ 0 điểm:"
                        }),
                        " mốc thời điểm m\xe0 xử l\xfd từ thời điểm n\xe0y vẫn xảy ra tai nạn"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body1",
                    children: [
                        " Học vi\xean lựa chọn được giữa 2 mốc n\xe0y sẽ đạt mức điểm tương ứng từ ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "5-4-3-2-1 điểm"
                        }),
                        " (điểm tối đa cho mỗi t\xecnh huống l\xe0 5đ)."
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var situation_VideoSection = (VideoSection);

;// CONCATENATED MODULE: ./src/sections/situation/SituationSection.js
/* eslint-disable react/prop-types */ 














var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    });
});
function SituationSection(param) {
    var categories = param.categories, nextItem = param.nextItem, prevItem = param.prevItem, situation = param.situation;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "sm");
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: themeStretch ? "xl" : "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 3,
                    mb: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SituationWelcome/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsContact/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SituationHeader/* SituationHeader */.C, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    mb: 5,
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 2.1,
                            children: [
                                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuSection/* default */.Z, {
                                    categories: categories
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(situation_VideoSection, {
                                    item: situation,
                                    prevItem: prevItem,
                                    nextItem: nextItem
                                }),
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    mt: 2,
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSection/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideSection/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleBannerAds */.D, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HackerthonAds/* default */.Z, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 9.9,
                            children: [
                                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(situation_VideoSection, {
                                    item: situation,
                                    prevItem: prevItem,
                                    nextItem: nextItem
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuSection/* default */.Z, {
                                    categories: categories
                                }),
                                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    p: 1,
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSection/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideSection/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleBannerAds */.D, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HackerthonAds/* default */.Z, {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    my: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleGridAds */.a, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Claimnation/* default */.Z, {})
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/thi-tinh-huong/[slug].js
/* eslint-disable react/prop-types */ 








Situation.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function Situation(param) {
    var categories = param.categories, situation = param.situation, prevItem = param.prevItem, nextItem = param.nextItem;
    var urlify = function urlify(text) {
        var anchors = /<img\s[^>]*?src=(["']?)([^\s]+?)\1[^>]*?>/ig;
        var links = [];
        text.replace(anchors, function(_anchor, _quote, url) {
            links.push(url);
        });
        return links === null || links === void 0 ? void 0 : links[0];
    };
    var imagePath = urlify(situation.description);
    var ref = (0,store/* useSelector */.v9)(function(state) {
        return state.blogComment;
    }), searchComment = ref.search;
    (0,react.useEffect)(function() {
        (0,store/* dispatch */.WI)((0,blog_comment/* setCommentSearch */.VG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchComment), {
            value: "",
            page: 0,
            filterBys: {
                itemId: situation.orderNo,
                type: "SITUATION"
            }
        })));
    }, [
        situation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: situation.metaTitle,
        description: situation.metaDescription,
        imagePath: imagePath,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SituationSection, {
            categories: categories,
            nextItem: nextItem,
            prevItem: prevItem,
            situation: situation
        })
    });
}


/***/ }),

/***/ 16634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10633);
/* harmony import */ var _components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77251);
/* harmony import */ var _components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37549);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29050);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33599);
/* harmony import */ var _CommentItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83741);
/* eslint-disable react-hooks/exhaustive-deps */ 



// @mui







// ----------------------------------------------------------------------
function CommentList() {
    var dispatch = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().translate;
    var ref = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }), comments = ref.comments, totalPages = ref.totalPages, isLoading = ref.isLoading, search = ref.search, numberOfElements = ref.numberOfElements;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"), sortBy = ref1[0], setSortBy = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .getComments */ .li)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        search
    ]);
    var handleChangePage = function(_, value) {
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: value - 1
        })));
    };
    var handleChangeSort = function(event) {
        var value = event.target.value;
        var orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        if (value === "0") orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        else if (value === "1") orders = [
            {
                order: "asc",
                property: "createdAt"
            }
        ];
        else orders = [
            {
                order: "desc",
                property: "likeNo"
            }
        ];
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: 0,
            orders: orders
        })));
        setSortBy(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        my: 1,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: [
                            translate("label.sortBy"),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        variant: "standard",
                        value: sortBy,
                        size: "small",
                        sx: {
                            fontSize: 12,
                            fontWeight: "bold",
                            ml: 1,
                            pt: 1
                        },
                        disableUnderline: true,
                        onChange: handleChangeSort,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "0",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByNew")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "1",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByOld")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "2",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByLike")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                spacing: 2,
                children: [
                    comments.map(function(comment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommentItem__WEBPACK_IMPORTED_MODULE_7__/* .CommentItemWrapper */ .w, {
                            comment: comment
                        }, comment.id);
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonCommentItem */ .bG, {}) : numberOfElements == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: " ",
                        description: translate("label.noComment")
                    })
                ]
            }),
            numberOfElements > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 86969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GuideSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable react/prop-types */ 


function GuideSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/thi-tinh-huong/meo-thi/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/icons/meo-lam-bai.png",
                style: {
                    borderRadius: 5,
                    cursor: "pointer"
                },
                alt: "mẹo l\xe0m b\xe0i",
                height: 103,
                width: 272,
                sizes: "cover"
            })
        })
    });
}


/***/ }),

/***/ 25893:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2544,5101,1160,3362,917,2077,5410,6461,1739,892,4538,1876,1284,5701,3559,4397,2225,6054,9774,2888,179], function() { return __webpack_exec__(23126); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);